"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Modal_styled_1 = require("./Modal.styled");
const Icon_1 = require("../Icon");
const margin = 16;
const Modal = ({ title, anchor, children, onClickOutside, height, isOpen, actions, width, fullSize }, ref) => {
    const $modalContainer = React.useRef(null);
    const [size, setSize] = React.useState(fullSize ? [0, 0, window.innerWidth - margin, window.innerHeight] : [50, 0, 480, height]);
    if (process.env.NODE_ENV === "development" &&
        fullSize &&
        (height !== undefined || width !== undefined || anchor !== undefined)) {
        console.warn("width, height and anchor are ignored when used together with fullSize");
    }
    // Focus the modal on open
    React.useEffect(() => {
        const currentModalContainer = $modalContainer.current;
        if (currentModalContainer && isOpen) {
            currentModalContainer.focus();
        }
    }, [isOpen]);
    // Anchor
    React.useEffect(() => {
        const currentAnchor = anchor && anchor.current;
        if (currentAnchor) {
            currentAnchor.scrollIntoView();
            const { top, left, width, height } = currentAnchor.getBoundingClientRect();
            setSize([top, left, width, height]);
        }
        if (fullSize) {
            setSize([0, 0, window.innerWidth - margin, window.innerHeight]);
        }
    }, [isOpen, anchor, fullSize]);
    // Resize
    React.useEffect(() => {
        if (isOpen && fullSize) {
            const handleResize = () => setSize([0, 0, window.innerWidth - margin, window.innerHeight]);
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }
    }, [isOpen, fullSize, setSize]);
    // Close on Escape
    React.useEffect(() => {
        if (onClickOutside) {
            const handleKeyDown = (e) => {
                if (e.key === "Escape") {
                    onClickOutside();
                }
            };
            document.addEventListener("keydown", handleKeyDown);
            return () => document.removeEventListener("keydown", handleKeyDown);
        }
    }, [onClickOutside]);
    if (!isOpen) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal_styled_1.Overlay, { onClick: onClickOutside }),
        React.createElement(Modal_styled_1.Container, { tabIndex: 0, ref: $modalContainer, top: size[0], left: size[1], width: width || size[2], height: height, modalHeight: $modalContainer.current && $modalContainer.current.clientHeight, anchorHeight: typeof size[3] === "number" && size[3] },
            React.createElement(Modal_styled_1.ModalCard, { ref: ref, fullSize: true, title: title, action: fullSize ? React.createElement(Icon_1.NoIcon, { onClick: onClickOutside }) : undefined },
                React.createElement(Modal_styled_1.ModalContent, { actions: Boolean(actions), anchor: Boolean(anchor), top: size[0] },
                    React.createElement(Modal_styled_1.ContentWrapper, null, children),
                    actions && React.createElement(Modal_styled_1.Actions, { childCount: actions.length }, actions))))));
};
exports.default = React.forwardRef(Modal);
//# sourceMappingURL=Modal.js.map